<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    :max-width="maxWidth"
    :persistent="persistent"
    :scrollable="scrollable"
    content-class="rounded-xl"
  >
    <v-card>
      <v-card-title
        class="justify-space-between"
        :class="{ border: borderHeader, shadow }"
      >
        <div>{{ title }}</div>
        <v-btn icon color="#000" @click="close" v-if="!isMobile">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="py-4">
        <slot name="content"></slot>
      </v-card-text>
      <v-card-actions :class="{ border: borderFooter, shadow }">
        <div class="dialog-actions">
          <slot name="footer">
            <v-btn
              @click="$emit('close')"
              color="primary"
              :title="closeText"
              :aria-label="closeText"
              rounded
              depressed
              :large="!btnSmall"
            >
              {{ closeText }}
            </v-btn>
          </slot>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "PopupCommon",
  components: {},
  props: {
    value: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ""
    },
    closeText: {
      type: String,
      default: "Zamknij"
    },
    persistent: {
      type: Boolean,
      default: true
    },
    scrollable: {
      type: Boolean,
      default: true
    },
    btnSmall: {
      type: Boolean,
      default: false
    },
    shadow: {
      type: Boolean,
      default: false
    },
    borderHeader: {
      type: Boolean,
      default: true
    },
    borderFooter: {
      type: Boolean,
      default: true
    },
    maxWidth: {
      type: [Number, String],
      default: 600
    }
  },
  data() {
    return {
      isValid: false,
      fullscreen: false,
      tabs: "edit",
      jsonData: {}
    };
  },

  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.dialog-actions {
  flex-wrap: wrap;
}
</style>
